import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, get, post, put } from "helpers/api_helper"
import {
  ADD_BRAND,
  DELETE_BRAND,
  GET_ALL_BRAND_LIST,
  GET_ALL_BRANDS,
  GET_BRAND_DETAILS,
  GET_BRAND_NAMES_LIST,
  TOGGLE_BRAND,
  UPDATE_BRAND,
  UPDATE_BRAND_STATUS,
  GET_ASSIGNED_BRANDS,
  SET_DEFAULT_BRAND,
} from "helpers/url_helper"

export const getBrandList = createAsyncThunk(
  GET_ALL_BRAND_LIST,
  async payload => {
    const response = await get(GET_ALL_BRAND_LIST, payload)
    return response
  }
)

export const getBrandNamesList = createAsyncThunk(
  GET_BRAND_NAMES_LIST,
  async () => {
    const response = await get(GET_BRAND_NAMES_LIST)
    return response
  }
)

export const getAllBrands = createAsyncThunk(GET_ALL_BRANDS, async payload => {
  const response = await post(GET_ALL_BRANDS, payload)
  return response
})

export const addBrand = createAsyncThunk(ADD_BRAND, async payload => {
  const response = await post(ADD_BRAND, payload)
  return response
})

export const getBrandDetails = createAsyncThunk(
  GET_BRAND_DETAILS,
  async ({ id }) => {
    const response = await get(`${GET_BRAND_DETAILS}/${id}`)
    return response
  }
)

export const updateBrand = createAsyncThunk(UPDATE_BRAND, async payload => {
  const { id, ...data } = payload
  const response = await put(`${UPDATE_BRAND}/${id}`, data)
  return response
})

export const deleteBrand = createAsyncThunk(DELETE_BRAND, async ({ id }) => {
  const response = await del(`${DELETE_BRAND}/${id}`)
  return response
})

export const updateBrandStatus = createAsyncThunk(
  UPDATE_BRAND_STATUS,
  async payload => {
    const { id, status } = payload
    const response = await put(`${UPDATE_BRAND_STATUS}/${id}`, { status })
    return response
  }
)

export const toggleBrand = createAsyncThunk(TOGGLE_BRAND, async ({ id }) => {
  const response = await post(`${TOGGLE_BRAND}/${id}`)
  return response
})

export const getAssignedBrands = createAsyncThunk(
  GET_ASSIGNED_BRANDS,
  async () => {
    const response = await get(GET_ASSIGNED_BRANDS)
    return response
  },
  {
    condition: (_, { getState }) => {
      const login = getState().Login
      const isSuperAdminSession =
        login?.accountScope === "super_admin" ||
        login?.accountType === "superadmin"
      if (isSuperAdminSession) {
        return false
      }

      const { assignedBrandsLoading, assignedBrandsLoaded } = getState().Brands
      // Avoid duplicate/refetch loops from multiple useAssignedBrands() callers
      if (assignedBrandsLoading || assignedBrandsLoaded) {
        return false
      }
      return true
    },
  }
)

export const setDefaultBrand = createAsyncThunk(
  SET_DEFAULT_BRAND,
  async payload => {
    const response = await put(SET_DEFAULT_BRAND, payload)
    return response
  }
)
